export const pendingUsersHeaders = [
  {
    value: "shareeEmail",
    text: "Sharee Email",
    sortable: false,
  },
  {
    value: "shareRequests",
    text: "N° of Share Requests",
    width: 90,
    sortable: true,
  },
]

export const shareeCamerasHeaders = [
  {
    value: "camera",
    text: "Camera",
    width: 200,
    sortable: true,
  },
  {
    value: "createdAt",
    text: "Shared On",
    width: 150,
    sortable: true,
  },
  {
    value: "sharer",
    text: "Sharer",
    width: 150,
    sortable: true,
  },
  {
    value: "rights",
    text: "Rights",
    width: 80,
    align: "center",
    sortable: true,
  },
  {
    value: "message",
    text: "Message",
    width: 400,
    sortable: true,
  },
]
